/* eslint-disable no-unused-vars */
import Types from "./types";
import { LeadServiceJava } from "../../../service/lead-service-java-api";

import { SELL_ONLINE_USER_CHOICE } from "../../../constants/app-constants";
import { CarService } from "../../../service/car-service";
import { VehicleService } from "../../../service/vehicle-service";
import { carConsumerService } from "../../../service/car-consumer-gateway-api";

const isSubmittingData = (flag) => ({
    type: Types.IS_SUBMITTING_DATA,
    flag
});

const isMMYVsEligible = (flag) => ({
    type: Types.SET_MMYVS_ELIGIBLITY,
    flag
});

const isGsEligible = (flag) => ({
    type: Types.SET_IS_GS_ELIGIBLE,
    flag
});

const postOfferPriceInputSuccess = (data) => () => ({
    type: Types.POST_OFFER_PRICE_INPUT_SUCCESS,
    data
});

const postOfferPriceInput = (payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.postOfferPriceInput(payload)
            .then(response => {
                dispatch(postOfferPriceInputSuccess({
                    userChoice: payload.quote_accepted,
                    isSubmitted: payload.quote_accepted === SELL_ONLINE_USER_CHOICE.SELL_NOW,
                    showFeedbackScreen: payload.quote_accepted !== SELL_ONLINE_USER_CHOICE.SELL_NOW
                }));
                resolve(response.data);
            })
            .catch(error => reject(error));
    });
};

const setCarPriceDetail = ({
    offeredPrice,
    sellerReview,
    fullname,
    appointmentId,
    phone,
    marketPrice,
    c24mp
}) => ({
    type: Types.SET_CAR_PRICE_DETAIL,
    offeredPrice,
    sellerReview,
    fullname,
    appointmentId,
    phone,
    marketPrice,
    c24mp
});

const setIsSubmitted = (isSubmitted) => ({
    type: Types.SET_IS_SUBMITTED,
    isSubmitted
});

const fetchLeadDetailFailure = (error) => ({
    type: Types.FETCH_LEAD_DETAIL_FAILURE,
    dealPaymentInfoError: error
});

const setAuctionData = (data) => ({
    type: Types.SET_AUCTION_DATA,
    data
});

const postOfferPriceFeedback = (payload) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.postSellOnlineFeedback(payload)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const sellOnlineCallBackLead = (payload) => dispatch => {
    dispatch(isSubmittingData(true));
    return new Promise((resolve, reject) => {
        LeadServiceJava.sellOnlineCallBack(payload)
            .then(response => {
                resolve(response);
                dispatch(isSubmittingData(false));
            })
            .catch(error => {
                reject(error);
                dispatch(isSubmittingData(false));
            });
    });
};

const setActiveScreen = (screen) => ({
    type: Types.SET_ACTIVE_SCREEN,
    screen
});

const setAnsweredQuestions = ({key, value}) => ({
    type: Types.STORE_ANSWERED_QUESTION,
    key,
    value
});

const postSellOnlineQuestion = (payload) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.postSellOnlineQuestion(payload)
            .then(response => {
                resolve(response.data.detail);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const setIsPincodeGsEligble = (flag) => ({
    type: Types.IS_PINCODE_GS_ELIGBLE,
    flag
});

const fetchAppointmentDetailSuccess = (data) => ({
    type: Types.FETCH_APPOINTMENT_DETAIL_SUCCESS,
    data
});

const fetchAppointmentDetailFailure = (error) => ({
    type: Types.FETCH_APPOINTMENT_DETAIL_FAILURE,
    error
});

const fetchAppointmentDetailsInit = (appointmentDetailsLoading) => ({
    type: Types.FETCH_APPOINTMENT_DETAIL_INIT,
    appointmentDetailsLoading
});

const fetchAppointmentDetail = (token, secureToken, loading = true) => dispatch => {
    dispatch(fetchAppointmentDetailsInit(loading));
    return new Promise((resolve, reject) => {
        LeadServiceJava.getAppointmentDetailsByTokenProtected(token, secureToken)
            .then(response => {
                dispatch(fetchAppointmentDetailSuccess(response));
                resolve(response);
            })
            .catch(error => {
                dispatch(fetchAppointmentDetailFailure(error));
                reject(error);
            });
    });
};

const fetchfetchLeadDetails = (token, params, secureToken) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.fetchLeadDetails(token, params, false, secureToken)
            .then(response => {
                resolve(response.data.detail);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const fetchDateSlotSuccess = (data) => ({
    type: Types.FETCH_DATE_SLOTS_SUCCESS,
    data
});

const fetchDateSlotFailure = (error) => ({
    type: Types.FETCH_DATE_SLOTS_FAILURE,
    error
});

const fetchDateSlotInit = (dateSlotLoading) => ({
    type: Types.FETCH_DATE_SLOTS_INIT,
    dateSlotLoading
});

const fetchSlotsByLocationSuccess = ({ zone, slots, locations }) => ({
    type: Types.FETCH_OFFER_SLOTS_BY_LOCATIONS_SUCCESS,
    zone,
    slots,
    locations
});
const fetchSlotsFailure = () => ({
    type: Types.FETCH_OFFER_SLOTS_BY_LOCATIONS_FAILURE
});
const fetchSlots = (params, isRevamped = false) => (dispatch) => {
    fetchDateSlotInit();
    return new Promise((resolve, reject) => {
        carConsumerService.fetchGeoSlots(params, isRevamped)
            .then(response => {
                dispatch(fetchSlotsByLocationSuccess(response));
                const location = response.zone && response.zone.location_id ? Object.values(response.slots).filter(element => element.location_id === response.zone.location_id)[0] : Object.values(response.locations).reduce((a, b) => parseInt(a.distance) < parseInt(b.distance) ? a : b);
                dispatch(fetchDateSlotSuccess(response.slots[location.location_id]));
                resolve(response);
            })
            .catch(error => {
                dispatch(fetchSlotsFailure());
                dispatch(fetchDateSlotFailure(error));
                reject(error);
            });
    });
};

const updateAppointmentBookingFailure = (error) => ({
    type: Types.UPDATE_APPOINTMENT_BOOKING_FAILURE,
    error
});

const updateAppointmentBookingInit = (updateAppointmentBookingLoading) => ({
    type: Types.UPDATE_APPOINTMENT_BOOKING_INIT,
    updateAppointmentBookingLoading
});

const setOfferPrice = (price) => ({
    type: Types.SET_OFFER_PRICE,
    price
});

const setCurrentQuestionIndex = (index) => ({
    type: Types.SET_CURRENT_QUESTION_INDEX,
    index
});

const setDataFromSSR = (data) => ({
    type: Types.SET_DATA_FROM_SSR,
    data
});

const updateAppointmentBooking = (token, params) => (dispatch) => {
    dispatch(updateAppointmentBookingInit(true));
    return new Promise((resolve, reject) => {
        LeadServiceJava.rescheduleAppointment(token, params)
            .then(response => {
                dispatch(fetchAppointmentDetail(token, false));
                resolve(response);
            })
            .catch(error => {
                dispatch(updateAppointmentBookingFailure(error));
                reject(error);
            });
    });
};

const updateAppointment = (token, params) => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.updateAppointment(token, params)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const updateSSR = (flag) => ({
    type: Types.SET_SSR,
    flag
});

const resetQuestions = () => ({
    type: Types.RESET_QUESTIONS
});

const getDocument = (appointmentId) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getDocument(appointmentId)
            .then(response => {
                resolve(response.data.detail);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const setRegistrationNo = (number) => ({
    type: Types.SET_REGISTRATION_NUMBER,
    number
});

const setLeadCreatedType = (leadType) => ({
    type: Types.SET_LEAD_CREATED_TYPE,
    leadType
});

const setDealerCode = (code) => ({
    type: Types.SET_DEALER_CODE,
    code
});

const getDealerCarPrice = (code) => ({
    type: Types.GET_DEALER_CAR_PRICE,
    code
});

const updateQuestionsArray = (questionArray) => ({
    type: Types.SET_QUESTIONS_ARRAY,
    questionArray
});

const getSellOnlinePrice = (appointmentId) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getSellOnlinePrice(appointmentId)
            .then(response => {
                resolve(response.data.detail);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const verifyOTPSuccess = () => ({
    type: Types.VERIFY_OTP_SUCCESS
});

const verifyOTP = (params) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.verifyOTP(params).then(response => {
            dispatch(verifyOTPSuccess());
            resolve(response.data.detail);
        }).catch(error => {
            reject(error);
        });
    });
};

const verifyLeadOTP = (params) => dispatch => {
    return new Promise((resolve, reject) => {
        CarService.verifyLeadOTP(params).then(response => {
            dispatch(verifyOTPSuccess());
            resolve(response.data.detail);
        }).catch(error => {
            reject(error);
        });
    });
};

const verifyOTPSend = () => ({
    type: Types.SEND_OTP_SUCCESS
});

const sendLeadOTP = (params)  => dispatch =>  {
    return new Promise((resolve, reject) => {
        LeadServiceJava.sendOTP(params).then((resp) => {
            dispatch(verifyOTPSend());
            resolve(resp);
        }).catch((e) => {
            reject(e);
        });
    });
};
const setIsSellOnlineCity = (flag) => ({
    type: Types.SET_IS_SELL_ONLINE_CITY,
    flag
});

const setUserReport = (report) => ({
    type: Types.SET_USER_REPORT,
    report
});

const getCancelReasons = ()  => dispatch =>  {
    return new Promise((resolve, reject) => {
        VehicleService.getAppointmentCancelReasons().then((resp) => {
            resolve(resp.data.detail);
        }).catch((e) => {
            reject(e);
        });
    });
};

const confirmCancelAppoiment = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.confirmCancelAppoiment(token, payload, true)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const setHypothecation = (hypothecation) => ({
    type: Types.SET_HYPOTHECATION,
    hypothecation
});

const reVerifyAppointment = ({ token, pvtAuth }) => dispatch =>  {
    return new Promise((resolve, reject) => {
        LeadServiceJava.reVerifyAppointment({ token, pvtAuth }, true)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export {
    setUserReport,
    setHypothecation,
    getCancelReasons,
    setCarPriceDetail,
    fetchLeadDetailFailure,
    postOfferPriceInput,
    setIsSubmitted,
    postOfferPriceFeedback,
    setAuctionData,
    sellOnlineCallBackLead,
    setActiveScreen,
    postSellOnlineQuestion,
    setIsPincodeGsEligble,
    fetchAppointmentDetail,
    fetchAppointmentDetailSuccess,
    fetchAppointmentDetailFailure,
    fetchAppointmentDetailsInit,
    fetchSlots,
    updateAppointmentBooking,
    updateAppointmentBookingInit,
    isMMYVsEligible,
    setAnsweredQuestions,
    isGsEligible,
    isSubmittingData,
    setOfferPrice,
    setCurrentQuestionIndex,
    setDataFromSSR,
    updateSSR,
    resetQuestions,
    setRegistrationNo,
    setLeadCreatedType,
    updateAppointment,
    getDocument,
    setDealerCode,
    updateQuestionsArray,
    getDealerCarPrice,
    getSellOnlinePrice,
    verifyOTP,
    fetchfetchLeadDetails,
    verifyLeadOTP,
    sendLeadOTP,
    setIsSellOnlineCity,
    confirmCancelAppoiment,
    reVerifyAppointment
};
